import * as THREE from "three";

export function createRenderer(canvas) {
  const targetWindow = canvas.ownerDocument.defaultView ?? window;
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
  });

  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  return {
    instance: renderer,
    render(scene, camera) {
      if (camera) renderer.render(scene, camera);
    },
    resize({ width, height }) {
      renderer.setSize(width, height);
      renderer.setPixelRatio(Math.min(targetWindow.devicePixelRatio, 2));
    },
    setTextureAnisotropy(texture) {
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
      texture.needsUpdate = true;
    },
    destroy() {
      renderer.dispose();
    },
  };
}
